import { render, staticRenderFns } from "./CheckoutQuadrants.vue?vue&type=template&id=53f85cd6&"
import script from "./CheckoutQuadrants.vue?vue&type=script&lang=js&"
export * from "./CheckoutQuadrants.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutQuadrants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
